import React, {Component} from "react";
import classNames from 'classnames'
import Style from './FJIntroItem.module.less'

class FJIntroItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isVideoShown: false,
    }
  }

  _onMouseEnter = () => {
    this.setState({isVideoShown: true});
  };

  _onMouseLeave = () => {
    this.setState({isVideoShown: false});
  };

  _handleClick = () => {
    this.props.onClick(this.props.id);
  };

  render() {
    const {thumbnail, url, selected, style} = this.props;
    const {isVideoShown} = this.state;
    return (
      <div className={classNames(Style.box, {[Style.selected]: selected})}
           style={style}
           onMouseEnter={this._onMouseEnter}
           onMouseLeave={this._onMouseLeave}
           onClick={this._handleClick}>
        <img className={Style.image} src={thumbnail} alt=''/>
        {
          isVideoShown && url ? <video className={Style.video} autoPlay loop src={url}/> : null
        }
      </div>
    );
  }
}

export default FJIntroItem;